import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getHgsRepository, { ServiceResponse } from './getHgs.repository';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

interface GetHgsParams {
  startDate: Date;
  endDate: Date;
  invoiceNo?: string;
}

export const getHgs = createAsyncThunk<ServiceResponse[], GetHgsParams>(
  'getHgs',
  async ({
    startDate,
    endDate,
    invoiceNo,
  }: GetHgsParams): Promise<ServiceResponse[]> => {
    return await getHgsRepository(startDate, endDate, invoiceNo).catch(
      (error: any) => {
        throw error;
      }
    );
  }
);

const serviceSlice = createSlice({
  name: 'getHgs',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHgs.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getHgs.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getHgs.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
